export default __webpack_public_path__ + "static/media/marvel-daredevil.2f4f1a57.jpg";